import {
    FixedPositionRequest,
    FixedPositionResponse,
} from 'component/Accommodation/Card/types';
import {
    UnitDataProps as UnitDetailResponse,
    UnitDetailRequest,
} from 'component/Accommodation/HolidayHome/Summary/types';
import { CalculationSampleResponse } from 'component/Incentive/Tooltip/Content/Discount/types';
import {
    AirportAcRequest,
    AirportAcResponse,
} from 'component/Search/Airport/types';
import {
    DestinationAcRequest,
    DestinationAcResponse,
} from 'component/Search/Destination/types';
import {
    OccupancySuggestionRequest,
    OccupancySuggestionResponse,
} from 'component/Search/Occupancy/types';
import {
    CsCodeUpdateRequest,
    CsCodeUpdateResponse,
} from 'component/User/Contact/types';
import { UserPostRequest, UserPostResponse } from 'component/User/Login/types';
import {
    RequestType as SemRequest,
    ResponseProps as SemHotelListResponse,
} from 'components/hotelList/types';

import {
    UnitListRequest,
    UnitListResponse,
} from 'pages/offers/component/Accommodation/List/HolidayHome/types';
import {
    IndividualSpotRequest,
    IndividualSpotResponse,
} from 'pages/offers/component/Incentive/IndividualSpot/__config/types';
import {
    SmsLinkRequest,
    SmsLinkResponse,
    VoucherRequest,
    VoucherResponse,
} from 'pages/prepaidVoucher/context/types';
import { DataProps as SemDestinationOverviewResponse } from 'pages/sem/component/types';

import { EndpointTypeDefinition } from 'utility/Request/Api/types';
import { PollingRequest, PollingResponse } from 'utility/Request/Polling/types';

import { ServicecodeRequest, ServicecodeResponse } from 'types/serviceCode';
import { ServiceDataRequest, ServiceDataResponse } from 'types/serviceData';

import {
    ActiveFilterRequest,
    ActiveFilterResponse,
} from 'proto/Api/ActiveFilter';
import {
    QuestionListRequest,
    QuestionListResponse,
} from 'proto/Api/Ask/GetQuestionList';
import {
    PostQuestionRequest,
    PostQuestionResponse,
} from 'proto/Api/Ask/PostQuestion';
import { ReportRequest, ReportResponse } from 'proto/Api/Ask/Report';
import {
    VoteAnswerRequest,
    VoteAnswerResponse,
} from 'proto/Api/Ask/VoteAnswer';
import { BlogRequest, BlogResponse } from 'proto/Api/Blog';
import {
    DropoutLinkRequest,
    DropoutLinkResponse,
} from 'proto/Api/Booking/DropoutLink';
import {
    SaveBookingRequest,
    SaveBookingResponse,
} from 'proto/Api/Booking/SaveBooking';
import {
    UpsellingListRequest,
    UpsellingListResponse,
    UpsellingSelectRequest,
    UpsellingSelectResponse,
} from 'proto/Api/Booking/Upselling';
import { ChatBotRequest, ChatBotResponse } from 'proto/Api/ChatBot';
import {
    GroupListRequest,
    GroupListResponse,
} from 'proto/Api/Community/GetGroupList';
import {
    HotelCustomerRatingRequest,
    HotelCustomerRatingResponse,
} from 'proto/Api/Hotel/CustomerRating';
import {
    HotelContentSearchRequest,
    HotelContentSearchResponse,
} from 'proto/Api/Hotel/HotelContentSearch';
import {
    HotelDetailsRequest,
    HotelDetailsResponse,
} from 'proto/Api/Hotel/HotelDetails';
import { HotelListRequest, HotelListResponse } from 'proto/Api/Hotel/HotelList';
import {
    HotelMediaRequest,
    HotelMediaResponse,
} from 'proto/Api/Hotel/HotelMedia';
import {
    PopularListRequest,
    PopularListResponse,
} from 'proto/Api/Hotel/PopularList';
import {
    RecommendationListRequest,
    RecommendationListResponse,
} from 'proto/Api/Hotel/RecommendationList';
import { KiFilterRequest, KiFilterResponse } from 'proto/Api/Llm/KiFilter';
import { NewsListRequest, NewsListResponse } from 'proto/Api/NewsList';
import {
    RoomDetailRequest,
    RoomDetailResponse,
} from 'proto/Api/Offer/RoomDetail';
import {
    PopularListRequest as PopularRegionListRequest,
    PopularListResponse as PopularRegionListResponse,
} from 'proto/Api/Region/PopularList';
import {
    CheckGptRequest,
    CheckGptResponse,
    CheckGptTrackingAnswerSubmittedRequest,
    CheckGptTrackingAskSubmittedRequest,
    CheckGptTrackingErrorRequest,
    CheckGptTrackingQuestionSubmittedRequest,
    CheckGptTrackingStopSubmittedRequest,
    CheckGptTrackingVoteSubmittedRequest,
} from 'proto/Api/Search/CheckGpt';
import { SuccessResponse } from 'proto/Api/Success';
import { TeaserRequest, TeaserResponse } from 'proto/Api/TourOperator/Teaser';
import {
    LastSearchesAddRequest,
    LastSearchesListRequest,
    LastSearchesListResponse,
} from 'proto/Api/User/LastSearches';
import {
    VacancyGetRequest,
    VacancyGetResponse,
} from 'proto/Api/Vacancy/VacancyGet';
import {
    VacancyProcessRequest,
    VacancyProcessResponse,
} from 'proto/Api/Vacancy/VacancyProcess';

import {
    FilterDataRequest,
    FilterDataResponse,
} from '../../proto/Api/Llm/FilterData';
import {
    ActivateVoucherRequest,
    ActivateVoucherResponse,
} from '../../proto/Api/PromotionalVoucher/ActivateSsoVoucher';
import { GetShortUrlRequest, GetShortUrlResponse } from '../legacy/shortUrl';

export enum ApiEndpoint {
    ActiveFilterList = 'activeFilterList',
    AirportAutocompleter = 'airportAutocompleter',
    BlogList = 'blogList',
    BookingSelectUpselling = 'bookingSelectUpselling',
    BookingUpsellingList = 'bookingUpsellingList',
    CalculationSample = 'calculationSample',
    ChatBot = 'chatBot',
    CheckGpt = 'checkGpt',
    CheckGptTrackingQuestionSubmitted = 'checkGptTrackingQuestionSubmitted',
    CheckGptTrackingAnswerSubmitted = 'checkGptTrackingAnswerSubmitted',
    CheckGptTrackingAskSubmitted = 'checkGptTrackingAskSubmitted',
    CheckGptTrackingVoteSubmitted = 'checkGptTrackingVoteSubmitted',
    CheckGptTrackingStopSubmitted = 'checkGptTrackingStopSubmitted',
    CheckGptTrackingError = 'checkGptTrackingError',
    CreateBooking = 'createBooking',
    CsCodePrepaidVoucher = 'csCodePrepaidVoucher',
    CsCodeUpdate = 'csCodeUpdate',
    DestinationAutoCompleter = 'DestinationAutoCompleter',
    DestinationAutoCompleterDestination = 'DestinationAutoCompleterDestination',
    DropoutInformation = 'dropoutInformation',
    FilterDataPrompt = 'filterDataPrompt',
    FixedPositionReport = 'fixedPositionReport',
    GetShortUrl = 'getshorturl',
    GetVacancy = 'getVacancy',
    GroupList = 'groupList',
    HotelContentSearch = 'hotelContentSearch',
    HotelCustomerRating = 'hotelCustomerRating',
    HotelDetails = 'hotelDetails',
    HotelList = 'hotelList',
    HotelMedia = 'hotelMedia',
    HotelRecommendationList = 'hotelRecommendationList',
    IndividualSpot = 'individualSpot',
    KiFilter = 'kiFilter',
    LastSearchesAdd = 'lastSearchesAdd',
    LastSearchesList = 'lastSearchesList',
    ListPolling = 'listPolling',
    NewsList = 'newsList',
    OccupancySuggestion = 'occupancySuggestion',
    PopularHotelList = 'popularHotelList',
    PopularRegionList = 'popularRegionList',
    QuestionList = 'questionList',
    QuestionPost = 'questionPost',
    ReportAnswer = 'reportAnswer',
    RoomDetail = 'roomDetail',
    SaveBooking = 'saveBooking',
    SemDestinationOverview = 'semDestinationOverview',
    SemHotelList = 'semHotelList',
    Servicecode = 'Servicecode',
    ServiceDataCmx = 'ServiceDataCmx',
    ServiceDataHolidayHome = 'ServiceDataHolidayHome',
    ServiceDataHotel = 'ServiceDataHotel',
    SmsLinkPrepaidVoucher = 'smsLinkPrepaidVoucher',
    TourOperatorTeaser = 'tourOperatorTeaser',
    UnifiedLoginRequired = 'unifiedLoginRequired',
    UnitDetail = 'unitDetail',
    UnitList = 'unitList',
    UserPost = 'userPost',
    VoteAnswer = 'voteAnswer',
    ActivateVoucher = 'activateVoucher',
}

export type EndpointTypeMap = {
    [ApiEndpoint.ActiveFilterList]: EndpointTypeDefinition<
        ActiveFilterRequest,
        ActiveFilterResponse
    >;
    [ApiEndpoint.AirportAutocompleter]: EndpointTypeDefinition<
        AirportAcRequest,
        AirportAcResponse
    >;
    [ApiEndpoint.BlogList]: EndpointTypeDefinition<BlogRequest, BlogResponse>;
    [ApiEndpoint.BookingSelectUpselling]: EndpointTypeDefinition<
        UpsellingSelectRequest,
        UpsellingSelectResponse
    >;
    [ApiEndpoint.BookingUpsellingList]: EndpointTypeDefinition<
        UpsellingListRequest,
        UpsellingListResponse
    >;
    [ApiEndpoint.CalculationSample]: EndpointTypeDefinition<
        never,
        CalculationSampleResponse
    >;
    [ApiEndpoint.CalculationSample]: EndpointTypeDefinition<
        never,
        CalculationSampleResponse
    >;
    [ApiEndpoint.ChatBot]: EndpointTypeDefinition<
        ChatBotRequest,
        ChatBotResponse
    >;
    [ApiEndpoint.CheckGpt]: EndpointTypeDefinition<
        CheckGptRequest,
        CheckGptResponse
    >;
    [ApiEndpoint.CheckGptTrackingAnswerSubmitted]: EndpointTypeDefinition<
        CheckGptTrackingAnswerSubmittedRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CheckGptTrackingAskSubmitted]: EndpointTypeDefinition<
        CheckGptTrackingAskSubmittedRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CheckGptTrackingQuestionSubmitted]: EndpointTypeDefinition<
        CheckGptTrackingQuestionSubmittedRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CheckGptTrackingVoteSubmitted]: EndpointTypeDefinition<
        CheckGptTrackingVoteSubmittedRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CheckGptTrackingStopSubmitted]: EndpointTypeDefinition<
        CheckGptTrackingStopSubmittedRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CheckGptTrackingError]: EndpointTypeDefinition<
        CheckGptTrackingErrorRequest,
        SuccessResponse
    >;
    [ApiEndpoint.CreateBooking]: EndpointTypeDefinition<
        VacancyProcessRequest,
        VacancyProcessResponse
    >;
    [ApiEndpoint.CsCodePrepaidVoucher]: EndpointTypeDefinition<
        VoucherRequest,
        VoucherResponse
    >;
    [ApiEndpoint.Servicecode]: EndpointTypeDefinition<
        ServicecodeRequest,
        ServicecodeResponse
    >;
    [ApiEndpoint.CsCodeUpdate]: EndpointTypeDefinition<
        CsCodeUpdateRequest,
        CsCodeUpdateResponse
    >;
    [ApiEndpoint.DestinationAutoCompleter]: EndpointTypeDefinition<
        DestinationAcRequest,
        DestinationAcResponse
    >;
    [ApiEndpoint.DestinationAutoCompleterDestination]: EndpointTypeDefinition<
        DestinationAcRequest,
        DestinationAcResponse
    >;
    [ApiEndpoint.DropoutInformation]: EndpointTypeDefinition<
        DropoutLinkRequest,
        DropoutLinkResponse
    >;
    [ApiEndpoint.FilterDataPrompt]: EndpointTypeDefinition<
        FilterDataRequest,
        FilterDataResponse
    >;
    [ApiEndpoint.FixedPositionReport]: EndpointTypeDefinition<
        FixedPositionRequest,
        FixedPositionResponse
    >;
    [ApiEndpoint.GetVacancy]: EndpointTypeDefinition<
        VacancyGetRequest,
        VacancyGetResponse
    >;
    [ApiEndpoint.GroupList]: EndpointTypeDefinition<
        GroupListRequest,
        GroupListResponse
    >;
    [ApiEndpoint.HotelContentSearch]: EndpointTypeDefinition<
        HotelContentSearchRequest,
        HotelContentSearchResponse
    >;
    [ApiEndpoint.HotelCustomerRating]: EndpointTypeDefinition<
        HotelCustomerRatingRequest,
        HotelCustomerRatingResponse
    >;
    [ApiEndpoint.HotelDetails]: EndpointTypeDefinition<
        HotelDetailsRequest,
        HotelDetailsResponse
    >;
    [ApiEndpoint.HotelList]: EndpointTypeDefinition<
        HotelListRequest,
        HotelListResponse
    >;
    [ApiEndpoint.HotelMedia]: EndpointTypeDefinition<
        HotelMediaRequest,
        HotelMediaResponse
    >;
    [ApiEndpoint.GetShortUrl]: EndpointTypeDefinition<
        GetShortUrlRequest,
        GetShortUrlResponse
    >;
    [ApiEndpoint.HotelRecommendationList]: EndpointTypeDefinition<
        RecommendationListRequest,
        RecommendationListResponse
    >;
    [ApiEndpoint.IndividualSpot]: EndpointTypeDefinition<
        IndividualSpotRequest,
        IndividualSpotResponse
    >;
    [ApiEndpoint.KiFilter]: EndpointTypeDefinition<
        KiFilterRequest,
        KiFilterResponse
    >;
    [ApiEndpoint.LastSearchesAdd]: EndpointTypeDefinition<
        LastSearchesAddRequest,
        SuccessResponse
    >;
    [ApiEndpoint.LastSearchesList]: EndpointTypeDefinition<
        LastSearchesListRequest,
        LastSearchesListResponse
    >;
    [ApiEndpoint.ListPolling]: EndpointTypeDefinition<
        PollingRequest,
        PollingResponse
    >;
    [ApiEndpoint.NewsList]: EndpointTypeDefinition<
        NewsListRequest,
        NewsListResponse
    >;
    [ApiEndpoint.OccupancySuggestion]: EndpointTypeDefinition<
        OccupancySuggestionRequest,
        OccupancySuggestionResponse
    >;
    [ApiEndpoint.PopularHotelList]: EndpointTypeDefinition<
        PopularListRequest,
        PopularListResponse
    >;
    [ApiEndpoint.PopularRegionList]: EndpointTypeDefinition<
        PopularRegionListRequest,
        PopularRegionListResponse
    >;
    [ApiEndpoint.QuestionList]: EndpointTypeDefinition<
        QuestionListRequest,
        QuestionListResponse
    >;
    [ApiEndpoint.QuestionPost]: EndpointTypeDefinition<
        PostQuestionRequest,
        PostQuestionResponse
    >;
    [ApiEndpoint.ReportAnswer]: EndpointTypeDefinition<
        ReportRequest,
        ReportResponse
    >;
    [ApiEndpoint.RoomDetail]: EndpointTypeDefinition<
        RoomDetailRequest,
        RoomDetailResponse
    >;
    [ApiEndpoint.SaveBooking]: EndpointTypeDefinition<
        SaveBookingRequest,
        SaveBookingResponse
    >;
    [ApiEndpoint.SemDestinationOverview]: EndpointTypeDefinition<
        SemRequest,
        SemDestinationOverviewResponse
    >;
    [ApiEndpoint.SemHotelList]: EndpointTypeDefinition<
        SemRequest,
        SemHotelListResponse
    >;
    [ApiEndpoint.ServiceDataHolidayHome]: EndpointTypeDefinition<
        ServiceDataRequest,
        ServiceDataResponse
    >;
    [ApiEndpoint.ServiceDataHotel]: EndpointTypeDefinition<
        ServiceDataRequest,
        ServiceDataResponse
    >;
    [ApiEndpoint.ServiceDataCmx]: EndpointTypeDefinition<
        ServiceDataRequest,
        ServiceDataResponse
    >;
    [ApiEndpoint.SmsLinkPrepaidVoucher]: EndpointTypeDefinition<
        SmsLinkRequest,
        SmsLinkResponse
    >;
    [ApiEndpoint.TourOperatorTeaser]: EndpointTypeDefinition<
        TeaserRequest,
        TeaserResponse
    >;
    [ApiEndpoint.UnifiedLoginRequired]: EndpointTypeDefinition<
        never,
        {
            status: string;
            uliRequired?: boolean;
        }
    >;
    [ApiEndpoint.UnitDetail]: EndpointTypeDefinition<
        UnitDetailRequest,
        UnitDetailResponse
    >;
    [ApiEndpoint.UnitList]: EndpointTypeDefinition<
        UnitListRequest,
        UnitListResponse
    >;
    [ApiEndpoint.UserPost]: EndpointTypeDefinition<
        UserPostRequest,
        UserPostResponse
    >;
    [ApiEndpoint.VoteAnswer]: EndpointTypeDefinition<
        VoteAnswerRequest,
        VoteAnswerResponse
    >;
    [ApiEndpoint.ActivateVoucher]: EndpointTypeDefinition<
        ActivateVoucherRequest,
        ActivateVoucherResponse
    >;
};
